import { hasRole, ROLES, type Role } from '@rp/contracts'
import type { SegmentedOption } from '../../design'
import { SESSION_COPY } from '../../session/copy'
import { SETTINGS_COPY } from './copy'

export const ROLE_OPTIONS: readonly SegmentedOption<Role>[] = ROLES.map((role) => ({
  value: role,
  label: SESSION_COPY.roleLabels[role],
  description: SETTINGS_COPY.roleHints[role],
}))

export const isDemotion = (from: Role, to: Role): boolean => !hasRole(to, from)

export const abilitiesLost = (from: Role, to: Role): readonly string[] =>
  ROLES.filter((role) => hasRole(from, role) && !hasRole(to, role)).map((role) => SETTINGS_COPY.roleAbilities[role])
